import Filter from "./features/Filter";
import List from "./features/List";
import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {PostExternalProductReadUserBeforeOrderListApiForm, ProductExSearchParamType, } from "./interface";
import {productExListMapInit, productExSearchParam2Init, productSideSearchParams} from "./state";
import {useReadProductByDoubleFilterEx} from "./hooks/useReadProductByDoubleFilterEx";
import {SubmitHandler, useForm} from "react-hook-form";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import { useUser } from "../../../../util/userContext/UserContext";
import { usePostExternalProductReadUserBeforeOrderList } from "./hooks/usePostExternalProductReadUserBeforeOrderList";

export default function ProductExList() {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;
    const { user } =  useUser();
    const {goToNavigation} = useGoToNavigation();

    const [searchParam, setSearchParam] = useState<ProductExSearchParamType>(productExSearchParam2Init);
    const [searchParams2, setSearchParams2 ] = useState<PostExternalProductReadUserBeforeOrderListApiForm>({...productSideSearchParams, userId: Number(user?.userId)});
    const {data: product} = useReadProductByDoubleFilterEx({param: searchParam});
    const {data: sideProduct} = usePostExternalProductReadUserBeforeOrderList({param: searchParams2});

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: searchParam,
    });

    const onSubmit: SubmitHandler<ProductExSearchParamType> = (submitData) => {
        goToNavigation(`product/list?pageNo=1`, {}, false)
        setSearchParam({...submitData, pageNo: 1});
    };

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page})
    }, [page]);

    return <>
        <Filter register={register}
                handleSubmit={handleSubmit(onSubmit)}
                watch={watch}/>

        <List product={product ?? productExListMapInit}
                sideProduct={sideProduct}
              register={register}
              handleSubmit={handleSubmit(onSubmit)}
              watch={watch}/>
    </>
}